import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './AlreadyVip.css'
import upgrade from '../assets/buy_now_btn.png'
import { formatEther } from '@ethersproject/units'
import { ethers } from 'ethers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import lottie from 'lottie-web';
import diamondSparkles from '../assets/Diamond_sparkles.json'
import fireworks from '../assets/Fireworks.json'
import sparkles from '../assets/Sparkles.json'
import confirmAudio from '../assets/zoombies_VIP_tx_confirm.mp3'
import FadeIn from 'react-fade-in'

const AlreadyVip = (props) => {
    
    const levels = [
        {
          index: 1,
          name: 'VIP',
          benefits: 
            [
                '1 Zoombies Farm Land NFT voucher*',
                'Exclusive access to VIP Miniverse Lounge & Events',
                'VIP only shop items',
                'VIP only chat emoji'
            ],
          img: require('../assets/vip.png'),
          color: '#00D1FF'
        }, 
        {
          index: 2,
          name: 'GOLD VIP',
          benefits: 
            [
                'ALL of VIP benefits',
                '1 Zoombies Island Land NFT voucher*',
                'Exclusive access to GOLD Miniverse Lounge & Events',
                'Unique GOLD level player Heroes',
                'GOLD only shop items',
                'GOLD only chat emojis',
                '30 Moonbeam NFT minting credits'
            ],
          img: require('../assets/goldvip.png'),
          color: '#FFC350'
        }, 
        {
          index: 3,
          name: 'DIAMOND VIP',
          benefits: 
            [
                'ALL of GOLD benefits',
                'Exclusive access to DIAMOND Miniverse Lounge & Events',
                'Unique DIAMOND level player Heroes',
                'DIAMOND only shop items',
                'DIAMOND only chat emoji',
                '100 Moonbeam NFT minting credits',
                'Merch pack',
                '/50 Zoombies stickers',
                '/T-shirt',
                '/Baseball cap',
                '/10 exclusive buttons'
            ],
          img: require('../assets/diamondvip.png'),
          color: '#00D1FF'
        }
    ]

    //Add a backslash '/' in front of any benefit to indent it

    const [ curr, setCurr ] = useState(levels[1]);
    const [ nextCost, setNextCost ] = useState(0);
    const [ isDiamond, setIsDiamond ] = useState(false);
    const [ buttonText, setButtonText ] = useState('UPGRADE');
    const diamondAnim1 = useRef(null);
    const diamondSparklesContainer1 = useRef(null);
    const diamondAnim2 = useRef(null);
    const diamondSparklesContainer2 = useRef(null);
    const fireAnim = useRef(null);
    const fireworksContainer = useRef(null);
    const sparkAnim = useRef(null);
    const sparklesContainer = useRef(null);

    useEffect( () => {
        let auto = false;
        if(props.vipStatus == 3) {
            auto = true;
        }

        if(diamondSparklesContainer1.current) {
            diamondAnim1.current = lottie.loadAnimation({
                container: diamondSparklesContainer1.current,
                renderer: "svg",
                loop: true,
                autoplay: auto,
                animationData: JSON.parse(JSON.stringify(diamondSparkles))
            })

            return () => {
                diamondAnim1.current?.destroy();
            }
        }
    }, [])

    useEffect( () => {
        let auto = false;
        if(props.vipStatus == 2) {
            auto = true;
        }

        if(diamondSparklesContainer2.current) {
            diamondAnim2.current = lottie.loadAnimation({
                container: diamondSparklesContainer2.current,
                renderer: "svg",
                loop: true,
                autoplay: auto,
                animationData: JSON.parse(JSON.stringify(diamondSparkles))
            })

            return () => {
                diamondAnim2.current?.destroy();
            }
        }
    }, [])

    useEffect( () => {
        if(fireworksContainer.current) {
            fireAnim.current = lottie.loadAnimation({
                container: fireworksContainer.current,
                renderer: "svg",
                loop: true,
                autoplay: false,
                animationData: JSON.parse(JSON.stringify(fireworks))
            })

            return () => {
                fireAnim.current?.destroy();
            }
        }
    }, [])

    useEffect( () => {
        if(sparklesContainer.current) {
            sparkAnim.current = lottie.loadAnimation({
                container: sparklesContainer.current,
                renderer: "svg",
                loop: true,
                autoplay: false,
                animationData: JSON.parse(JSON.stringify(sparkles))
            })

            return () => {
                sparkAnim.current?.destroy();
            }
        }
    }, [])

    const playConfirmSound = () => {     
        const audio = new Audio(confirmAudio);
        audio.play();
    }

    useEffect(() => {
        let index = props.vipStatus - 1;
        setCurr(levels[index]);

    }, [props.vipStatus, props.upgradeCost])

    useEffect(() => {
        setNextCost(props.upgradeCost);
    }, [props.upgradeCost])
    
    // const is_diamond = () => {
    //     if(curr.index == 3) {
    //         isDiamond = true;
    //     }    
    // }
    // is_diamond();

    useEffect(() => {
        if(curr && curr.index == 3) {
            setIsDiamond(true);
        }  
    }, [curr])
    
    
    const calculateGasMargin = (value) => {
        return value.mul(120).div(100)
    }
    
    const upgradeVipHandler = async () => {
        
        // console.log(ethers.utils.parseUnits((nextCost).toString()).toString());
        try {
            
            setButtonText('Pending...');
            const gasEstimate = await props.vip.estimateGas.upgrade(
                props.account, 
                { value: ethers.utils.parseUnits((nextCost).toString()).toString()}
            );

            const tx = await props.vip.upgrade(
                props.account, 
                { 
                    value: ethers.utils.parseUnits((nextCost).toString()).toString(), 
                    gasLimit: calculateGasMargin(gasEstimate)
                }
            );

            const toastid = toast.loading("Confirmed, pending...");
            props.setPending(true);
            let receipt = await tx.wait();
            // console.log(receipt);
            if(receipt.blockNumber) {
                playConfirmSound();
                sparkAnim.current?.play();
                fireAnim.current?.play(); 
                toast.update(toastid, { render: "Success", type: "success", isLoading: false , theme: "dark"});
                setTimeout(() => { window.location.reload() }, 3000);
            }
            else {
                toast.update(toastid, { render: "Transaction failed", type: "error", isLoading: false , theme: "dark" });
                setTimeout(() => { window.location.reload() }, 3000);
            }
            // props.vip.upgrade(props.account, { value: ethers.utils.parseUnits((nextCost).toString()).toString()});
        }
        catch(err) {
            // console.log(err);
            setButtonText('UPGRADE');
            const code = err.code.toString();
            
            if(code == 'ACTION_REJECTED') {
                toast.warning('You have cancelled this transaction');
            }
            else if(code == '-32603' && err.data.message == 'evm error: OutOfFund') {
                toast.error('Insufficient funds');
            }
            else {
                toast.error('Invalid input');
            }
        }
    }

    useEffect(() => {
        if(props.pending) {
            setButtonText('Confirming...');
        }
        else {
            setButtonText('UPGRADE');
        }
    }, [props.pending]) 
    

    return (
        curr ?
        <div className="bbig-container">
            {
                ReactDOM.createPortal(
                    <>
                        <span ref={fireworksContainer} className='confirm-lotties'></span>
                        <span ref={sparklesContainer} className='confirm-lotties'></span>
                    </>, 
                    document.getElementById('overlay-root')
                )
            }
            <div className="bvip-level">You are a {curr.name}!</div>
            <div className="bsmall-container">
                <FadeIn className="btext-left">
                    <div className="bheadings" style={{color: levels[curr.index - 1].color}}>Your MEMBERSHIP BENEFITS</div>
                    <div className={curr.index == 2 ? "bbenefits smaller-text" : "bbenefits"}>
                    <ul>
                    {
                        curr.benefits.map((point) => {
                            if(point.startsWith('/')) {
                                return <li key={Math.random()} style={{marginLeft: '7%', fontSize: '1.1vw'}}>{point.substring(1)}</li> 
                            }
                            else {
                                return <li key={Math.random()}>{point}</li> 
                            }
                        }   
                        )
                    }
                    </ul>
                    </div>
                </FadeIn>
                <div className="btext-right">
                    <div className="bvip-holder">
                        <div className="br-images">
                            <img src={curr.img} className="bvip-img" alt="Vip level"/>
                            <span ref={diamondSparklesContainer1} className='diamond-lottie-container'></span>    
                        </div>
                        <div className="bcost-text">{curr.name}</div>
                    </div>
                </div>
            </div>
            {
            !isDiamond && levels[curr.index] ?
            <div className="bsmall-container">
                <FadeIn className="btext-left">
                    <div className="bheadings bottom" style={{color: levels[curr.index].color}}>UPGRADE to {levels[curr.index].name} for added benefits!</div>
                    <div className={curr.index == 2 ? "bbenefits smaller-text" : "bbenefits"}>
                    <ul>
                    {
                        levels[curr.index].benefits.map((point) => {
                            if(point.startsWith('/')) {
                                return <li key={Math.random()} style={{marginLeft: '7%', fontSize: '1.1vw'}}>{point.substring(1)}</li> 
                            }
                            else {
                                return <li key={Math.random()}>{point}</li> 
                            }
                        } 
                        )
                    }
                    </ul>
                    </div>
                </FadeIn>
                <div className="btext-right">
                    <div className="random-holder">
                        <div className="bvip-holder">
                            <div className="br-images">
                                <img src={levels[curr.index].img} className="bvip-img" alt="Vip level"/>
                                <span ref={diamondSparklesContainer2} className='diamond-lottie-container'></span>
                            </div>
                            <div className="bcost-text">{`${nextCost} ${props.currency}`}</div>
                        </div>
                        {
                            props.correctChain ?
                            <div className={buttonText == 'UPGRADE' ? 'bbuy-now-div' : 'bbuy-now-div disabled'} onClick={upgradeVipHandler}>
                                <img src={upgrade} className="bbuy-now-img" alt="Buy Now"/>
                                <div className="upgrade-text">{buttonText}</div>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
            : <></>
            }   
        </div>
        : <></>
    )
}

export default AlreadyVip